// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogSearchBox_card__2pqoV","warning-letter-filter-wrapper":"BlogSearchBox_warning-letter-filter-wrapper__1lf0-"};